(function () {
  'use strict';

  function initCollectionsTab(section) {
    var tabs   = Array.from(section.querySelectorAll('.by-ct__tab'));
    var panels = Array.from(section.querySelectorAll('.by-ct__panel'));
    var prevBtn = section.querySelector('.by-ct__nav-prev');
    var nextBtn = section.querySelector('.by-ct__nav-next');

    var swipers     = [];
    var activeIndex = 0;

    // ── Update prev/next disabled state for the active swiper ─
    function syncNavBtns() {
      var s = swipers[activeIndex];
      if (!s) return;
      if (prevBtn) prevBtn.disabled = s.isBeginning;
      if (nextBtn) nextBtn.disabled = s.isEnd;
    }

    // ── Init one Swiper per panel ────────────────────────────
    panels.forEach(function (panel) {
      var el = panel.querySelector('.by-ct__swiper');
      if (!el) { swipers.push(null); return; }

      var swiper = new Swiper(el, {
        slidesPerView: 4,
        spaceBetween: 30,
        breakpoints: {
          0:    { slidesPerView: 1.5, spaceBetween: 12 },
          480:  { slidesPerView: 2,   spaceBetween: 16 },
          768:  { slidesPerView: 2.5, spaceBetween: 20 },
          1024: { slidesPerView: 4,   spaceBetween: 30 }
        },
        on: {
          init:        syncNavBtns,
          slideChange: syncNavBtns,
          resize:      syncNavBtns
        }
      });
      swipers.push(swiper);
    });

    // Set initial state once all swipers are ready
    syncNavBtns();

    // ── Tab switching ────────────────────────────────────────
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = parseInt(tab.dataset.tabIndex, 10);
        if (idx === activeIndex) return;

        tabs.forEach(function (t) {
          t.classList.remove('by-ct__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('by-ct__tab--active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(function (p) { p.classList.remove('by-ct__panel--active'); });
        panels[idx].classList.add('by-ct__panel--active');

        activeIndex = idx;

        if (swipers[idx]) swipers[idx].update();
        syncNavBtns();
      });
    });

    // ── Shared nav buttons ───────────────────────────────────
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (swipers[activeIndex]) swipers[activeIndex].slidePrev();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (swipers[activeIndex]) swipers[activeIndex].slideNext();
      });
    }

    // ── Cart buttons ─────────────────────────────────────────
    section.querySelectorAll('.by-fc__add-to-cart, .by-fc__cart-circle').forEach(function (btn) {
      if (btn.dataset.ctInitialized) return;
      btn.dataset.ctInitialized = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        handleCartAction(btn);
      });
    });
  }

  function handleCartAction(btn) {
    var variantId    = btn.dataset.variantId;
    if (!variantId) return;

    var isBarBtn     = btn.classList.contains('by-fc__add-to-cart');
    var originalText = btn.textContent;

    btn.disabled = true;
    if (isBarBtn) btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (isBarBtn) btn.textContent = 'Added!';
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { item_count: cart.item_count }
        }));
        setTimeout(function () {
          btn.disabled = false;
          if (isBarBtn) btn.textContent = originalText;
        }, 1500);
      })
      .catch(function () {
        btn.disabled = false;
        if (isBarBtn) btn.textContent = originalText;
      });
  }

  function waitForSwiper(cb) {
    if (typeof Swiper !== 'undefined') { cb(); return; }
    var t = setInterval(function () {
      if (typeof Swiper !== 'undefined') { clearInterval(t); cb(); }
    }, 50);
  }

  function init() {
    document.querySelectorAll('.by-collections-tab').forEach(function (section) {
      waitForSwiper(function () { initCollectionsTab(section); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.by-collections-tab');
    if (section) {
      waitForSwiper(function () { initCollectionsTab(section); });
    }
  });

})();
